import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Base } from '@fiverr-private/modal/src';
import * as Translations from '../providers/i18n';

import './style.scss';

const COLLABORATION_INTRO_MODAL_WALKTHROUGH = 'collaboration-intro-modal:walkthrough';

const WalkThroughIntro = ({ startTour, i18n }) => {
    const collaborationIntroShownInPast = localStorage.getItem(COLLABORATION_INTRO_MODAL_WALKTHROUGH);
    if (collaborationIntroShownInPast) {
        return null;
    }

    localStorage.setItem(COLLABORATION_INTRO_MODAL_WALKTHROUGH, 'true');

    return (
        <div>
            <Base name="collaboration-walkthrough-intro-modal"
                bindBodyClickListener={false}
                closeOnEscape={false}
                autoOpen={true}>
                {({ close }) => (
                    <div className="intro-content">
                        <div className="video-intro">
                            <iframe src="https://player.vimeo.com/video/311079653?title=0&byline=0&portrait=0"
                                frameBorder="0"
                                allowFullScreen
                                width="400"
                                height="167"/>
                        </div>
                        <div className="text-body font-accent">
                            <p>{i18n.t('attachments_preview.walkthrough.welcome_to_new_tool')}</p>
                            <p className="sub-text">{i18n.t('attachments_preview.walkthrough.take_a_quick_tour')}</p>
                        </div>
                        <div className="buttons">
                            <button className="btn-lrg-standard btn-start-tour" onClick={compose(startTour, close)}>
                                {i18n.t('attachments_preview.walkthrough.start')}
                            </button>
                        </div>
                    </div>
                )}
            </Base>
        </div>
    );
};

WalkThroughIntro.propTypes = {
    startTour: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(WalkThroughIntro);
